"use strict";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateContent = void 0;
const lit_html_1 = require("../lit-html");
const directive_1 = require("../directive");
class TemplateContentDirective extends directive_1.Directive {
    constructor(partInfo) {
        super(partInfo);
        if (partInfo.type !== directive_1.PartType.CHILD) {
            throw new Error('templateContent can only be used in child bindings');
        }
    }
    render(template) {
        if (this._previousTemplate === template) {
            return lit_html_1.noChange;
        }
        this._previousTemplate = template;
        return document.importNode(template.content, true);
    }
}
/**
 * Renders the content of a template element as HTML.
 *
 * Note, the template should be developer controlled and not user controlled.
 * Rendering a user-controlled template with this directive
 * could lead to cross-site-scripting vulnerabilities.
 */
exports.templateContent = (0, directive_1.directive)(TemplateContentDirective);
